import { render, staticRenderFns } from "./DonorPhone.vue?vue&type=template&id=28f38d4b&"
import script from "./DonorPhone.vue?vue&type=script&lang=js&"
export * from "./DonorPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports